import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as Yup from "yup";
import { verifyPassword } from "../api/axios/requests";

export default function ConfirmPasswordModal({ show, handleClose, onSuccess }) {
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      password: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required("Нууц үгээ оруулна уу")
        .min(4, "Хамгийн багадаа 4 тэмдэгт байна"),
    }),

    onSubmit: async (values, { setFieldError, resetForm }) => {
      setLoading(true);
      try {
        const res = await verifyPassword({ password: values.password });

        if (res.success) {
          toast.success("Нууц үг баталгаажлаа");
          if (typeof onSuccess === "function") {
            onSuccess();
          }
          resetForm();
          handleClose();
        } else {
          setFieldError("password", "Нууц үг буруу байна");
        }
      } catch (err) {
        setFieldError("password", "Нууц үг буруу байна");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      onExit={() => formik.resetForm()}
    >
      <Modal.Header closeButton className="bg-danger">
        <Modal.Title className="text-white">Баталгаажуулах</Modal.Title>
      </Modal.Header>

      <Form onSubmit={formik.handleSubmit}>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Нууц үг</Form.Label>

            <div className="position-relative">
              <div className="input-group input-group-merge">
                <input
                  id="password"
                  type={showPw ? "text" : "password"}
                  name="password"
                  placeholder="Нууц үг"
                  className={`form-control ${
                    formik.touched.password && formik.errors.password
                      ? "is-invalid"
                      : ""
                  }`}
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />

                <div
                  className="input-group-text"
                  onClick={() => setShowPw(!showPw)}
                  style={{ cursor: "pointer" }}
                >
                  {showPw ? (
                    <span className="ri ri-eye-off-line" />
                  ) : (
                    <span className="ri ri-eye-line" />
                  )}
                </div>
              </div>

              {formik.touched.password && formik.errors.password && (
                <div className="invalid-feedback d-block">
                  {formik.errors.password}
                </div>
              )}
            </div>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Болих
          </Button>

          <Button variant="danger" type="submit" disabled={loading}>
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                />
                Баталгаажуулж байна...
              </>
            ) : (
              "Баталгаажуулах"
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
